import { ThemeProvider } from "@mui/material/styles"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { BrowserRouter as Router } from "react-router-dom"
import { theme } from "./assets/theme"
import { Layout } from "./components/Layout/Layout"
import { RootProvider } from "./store/Context"
import "./App.css"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { useEffect } from "react"
import { ErrorBoundary } from "./components/ErrorBoundary"
import { GlobalProgressBar } from "./components/GlobalProgressBar"
import { NexusSnackbar } from "./components/Snackbar/Snackbar"
import { useTitle } from "./hooks/useTitle"
import { MainRoutingSwitch } from "./routing/MainRoutingSwitch"
import { useDbStateStore } from "./zstore/DbStateStore"

export const nexusQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Don't retry queries so the system works in more expected and less confusing ways.
            retry: false,
        },
    },
})

export const App = () => {
    useTitle()

    const fetchDbState = useDbStateStore((state) => state.fetchDbState)

    /**
     * Perform app startup requests
     */
    useEffect(() => {
        fetchDbState()
    }, [])

    return (
        <QueryClientProvider client={nexusQueryClient}>
            <RootProvider>
                <ThemeProvider theme={theme}>
                    <ErrorBoundary>
                        <Router>
                            <Layout>
                                <MainRoutingSwitch />
                            </Layout>
                        </Router>
                        <GlobalProgressBar />
                        <NexusSnackbar />
                    </ErrorBoundary>
                </ThemeProvider>
            </RootProvider>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    )
}
